"use client";

import { useEffect, useState } from "react";
import IntroPage from "./home";
import AboutYourBrandPage from "./about_your_brand";
import MainPointOfContactPage from "./main_point_of_contact";
import BrandOwnershipPage from "./brand_ownership";
import BusinessEngagementModelPage from "./business_engagement_model";
import SuccessBrandsPage from "./success";
import Navbar from "../components/BrandsPartnerComponents/navbar";
import CustomLoader from "../components/BrandsPartnerComponents/CustomLoader";
import NavigationButton from "../components/BrandsPartnerComponents/navigation_button";
// import ExpandBrandPage from "./expand";
import { BrandsType } from "./dtos/brands.dtos";
import { BrandsOnboardingProvider } from "../../contexts/BrandsOnboardingContext";
// import TailorYourApproachPage from "./tailor_your_approach";
import { createNewBrand } from "../../API/endpoints/Brands";
import { notification } from "antd";
import AreaOfExpertisePage from "./area_of_expertise";
import TableUiExpansionEdge from "./table";

// --- Inner component that must be wrapped by the provider ---
const BrandsOnboardingContent = ({
  step,
  setStep,
  isMobile,
}: {
  step: number;
  setStep: (n: number) => void;
  isMobile: boolean;
}) => {
  const totalSteps = 8;
  const nextStep = ()=>{ setStep(step + 1)
    console.log("DATA UPTO THIS SCREEN",data);
  };
  const previousStep = () => setStep(step - 1);
  const progressPercentage = ((step - 1) / (totalSteps - 1)) * 100;

  const [data, setData] = useState<BrandsType>({
    company_name: "",
    country_of_origin: undefined,
    company_registration_number: "",
    company_address_line1: "",
    // company_address_line2: "",
    company_address_postal_code: "",
    website: "",
    city: "",
    state: "",
    email_id: "",
    first_name: "",
    contact_number: "",
    contact_number_code: "",
    designation: "",
    brand_name: "",
    current_revenue: "",
    years_of_operation: "",
    exclusivity_tenure: "",
    marketing_investments: "",
    // market_preference:[ {
    //   region: 0,
    //   regulatory_compliance: false,
    //   importation_clearance: false,
    //   marketing: false,
    //   retail_distribution: false,
    //   offline_retail: false,
    //   online: false,
    //   food_service: false,
    //   ambient_warehousing: false,
    //   cold_and_frozen_warehousing: false,
    //   sales: false,
    // }],
    engagement_model: [],
    fob_preference: [],
    financial_assistance: [],
    // digitalPresence: {
    //   // website: "",
    //   social_media: [
    //     {
    //       platform: "",
    //       number_of_followers: undefined,
    //       url: "",
    //     },
    //   ],
    //   market_place: [
    //     {
    //       platform: "",
    //       store_rating: undefined,
    //       url: "",
    //     },
    //   ],
    // },
    // focus_categories: [
    //   {
    //     category: "",
    //     sub_category: [],
    //   },
    // ],
  });

  const stepTitles = [
    "",
    "About Your Brand",
    "Main Point of Contact",
    "Brand Ownership",
    "Expand Your Brand",
    "Business Engagement Model",
    "",
  ];
  const [api, contextHolder] = notification.useNotification();

 
  const [notificationData, setNotificationData] = useState<{
    message: string;
    description: string;
  } | null>(null);
  
  useEffect(() => {
    if (notificationData) {
      api.error({
        message: notificationData.message,
        description: notificationData.description,
        placement: "topRight",
      });
      setNotificationData(null); // reset after showing
    }
  }, [notificationData, api]);
  
  
//create brand with data


const handleCreateBrand = async () => {
  try {
    await createNewBrand(data);
    nextStep();
  } catch (err: any) {
    console.error("Error =>", err);

    const message = "Failed to create partner";
    const description =
      err?.response?.data?.message || err?.message || JSON.stringify(err);

    setNotificationData({ message, description });
  }
};


  return (
    <>
     {contextHolder}
      <Navbar
        progressPerc={progressPercentage}
        step={step - 1}
        totalSteps={totalSteps - 1}
        stepName={stepTitles[step - 1]}
      />

      <div
        className="min-h-screen w-full h-full bg-cover bg-no-repeat bg-center common-padding bg-gradient-to-br from-[#d2e0fe] via-[#dfe9fe] to-white"
        style={{ backgroundImage: `url('/images/bg-ith-app.svg')` }}
      >
        
        {step === 1 && <IntroPage />}
        {step === 2 && <AboutYourBrandPage data={data} setData={setData} nextStep={nextStep} previousStep={previousStep} isMobile={isMobile} />}
        {step === 3 && <MainPointOfContactPage data={data} setData={setData} nextStep={nextStep} previousStep={previousStep} isMobile={isMobile} />}
        {step === 4 && <BrandOwnershipPage data={data} setData={setData} nextStep={nextStep} previousStep={previousStep} isMobile={isMobile} />}
        {step === 5 && (
          <AreaOfExpertisePage
          data={data} setData={setData} nextStep={nextStep} previousStep={previousStep} isMobile={isMobile} 
          />
        )}
        {step === 6 && (
         
          <TableUiExpansionEdge nextStep={nextStep} previousStep={previousStep} data={data} setData={setData} />
        )}

        {/* {step === 7 && <TailorYourApproachPage data={data} nextStep={nextStep} previousStep={previousStep} setData={setData} />} */}
        {step === 7 && <BusinessEngagementModelPage data={data} nextStep={handleCreateBrand} previousStep={previousStep} setData={setData}  />}
        {step === 8 && <SuccessBrandsPage />}

        {!isMobile && step ===1 && (
          <div
            className={`${
              step === 1 ? "" : "mt-[60px]"
            } inline-flex flex justify-start gap-x-[8px] w-full`}
          >
            {step !== 1&& (
              <NavigationButton onClick={previousStep} label="Previous" type="text" />
            )}
            <NavigationButton
              onClick={nextStep}
              label={"Next"}
              type="primary"
            />
          </div>
        )}
      </div>
      <div className="h-[100px] block md:hidden"></div>
      {isMobile && step ===1 && (
        <div className="fixed bottom-0 left-0 right-0 flex justify-center px-[20px] py-4 gap-x-[8px] w-full bg-white shadow-lg">
          {step !== 1 && (
            <NavigationButton onClick={previousStep} label="Previous" type="text" block />
          )}
          <NavigationButton
            onClick={nextStep}
            label={ "Next"}
            type="primary"
            block
          />
        </div>
      )}
    </>
  );
};

// --- Wrapper with provider and loading ---
const BrandsOnboarding = () => {
  const [loading, setLoading] = useState(true);
  const [step, setStep] = useState(1);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <CustomLoader />
      </div>
    );
  }

  return (
    <BrandsOnboardingProvider>
      <BrandsOnboardingContent step={step} setStep={setStep} isMobile={isMobile} />
    </BrandsOnboardingProvider>
  );
};

export default BrandsOnboarding;